import React from 'react';
import { useSelector } from 'react-redux';
import { Field, Message, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetResultsSection, WorksheetsResultsMessagesSection } from '../../../Core';
import { MddChartSection } from '../../Shared';

const contextCaptions = [
  {
    path: `data.Preparation.SpecificGravityCoarse.AssociatedOversizeMoisture.MeasuredTest.DryingTray`,
    caption: 'Coarse Material Water Content',
  },
  {
    path: `data.Preparation.AssociatedFineMoisture.MeasuredTest.DryingTray`,
    caption: 'Passing Material Water Content',
  },
  { path: `data.TestPortions`, caption: 'Test Portions' },
  { path: `data.Preparation.ScreeningASTM`, caption: 'Oversize Determination' },
];
const excludeMessagePaths = [`data.Results`];

let AstmResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const correctionRequired = (useSelector(createWorksheetSelector!('Preparation.OversizeCorrectionRequired')) ??
    false) as boolean;
  return (
    <WorksheetResultsSection heading="Results">
      <MddChartSection />
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} excludeMessagePaths={excludeMessagePaths} />
      <ListFieldSection heading="Laboratory Results">
        <Field label="Maximum Dry Unit Weight" input={<TextOutput />} name="Results.MaximumDryUnitWeight" emph />
        <Field label="Optimum Water Content (%)" input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
      </ListFieldSection>
      {correctionRequired ? (
        <ListFieldSection heading="Corrected for Oversize">
          <Field
            label="Adjusted Maximum Dry Unit Weight"
            input={<TextOutput />}
            name="Results.AdjustedMaximumDryUnitWeight"
            emph
          />
          <Field
            label="Adjusted Optimum Water Content (%)"
            input={<TextOutput />}
            name="Results.AdjustedOptimumMoistureContent"
            emph
          />
        </ListFieldSection>
      ) : (
        <Message border={false}>Compaction data not corrected for oversize material</Message>
      )}
      <ListFieldSection name="Results" /* for results messages */ />
    </WorksheetResultsSection>
  );
};

AstmResultsSection = withInjectedProps(AstmResultsSection);

export { AstmResultsSection };
export default AstmResultsSection;
